import React from "react";
import ShowOffer from "./ShowOffer";
import ShowUser from "./ShowUser/ShowUser";
import Parse from "parse";
import { useParams } from "react-router-dom";
import { useMemo, useState, useEffect } from "react";
import Navbar from "./NavBar/NavBar";
import moment from "moment-with-locales-es6";
import { Flex, useId, Text } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { Grid } from "@mantine/core";

function AfficherOffres() {
  async function fetchOffer() {
    const Offer = Parse.Object.extend("Annonce");
    const query = new Parse.Query(Offer);
    query.equalTo("type", "job");
    query.equalTo("objectId", id);
    setOffreId(id);
    const offer = await query.find();
    setOffre(offer);
    const candidatsParOffre = offer[0].get("listUser");
    console.log(candidatsParOffre);
    setCandidatsToShow(candidatsParOffre);
    return offer;
  }

  const [offre, setOffre] = useState();
  const [candidatsToShow, setCandidatsToShow] = useState();
  const [offreId, setOffreId] = useState();

  useEffect(() => {
    fetchOffer();
  }, []);

  useEffect(() => {
    if (!offre) return;
  }, [offre]);

  const { id } = useParams();

  return (
    <Box display="flex" w={"100%"}>
      <Navbar />
      <Box
        mt={["20px", "20px", "0px", "0px"]}
        w={"100%"}
        mb={["120px", "120px", "0px", "0px"]}
      >
        <Text
          ml={["20px", "20px", "40px", "40px"]}
          fontFamily={"Sofia pro"}
          fontSize={"5xl"}
          fontWeight={"bolder"}
        >
          Afficher Offre
        </Text>
        <Box
          p="0px"
          mx={["10px", "10px", "50px", "50px"]}
          mt={["20px", "20px", "0px", "0px"]}
          w={["100%", "100%", "calc(100% - 100px) ", "calc(100% - 100px)"]}
          h={["100%", "100%", "calc(100% - 200px) ", "calc(100% - 200px)"]}
          bg="white"
          borderRadius={"25px"}
        >
          {offre ? (
            <Flex>
              <Grid gutter="lg" w={"100%"}>
                <Grid.Col key="1" xs={12} sm={12} md={8} lg={8} xl={8}>
                  <Box bg="white" w="100%" borderRadius="20px">
                    <ShowOffer
                      nomOffre={offre[0].get("titre")}
                      contrat={offre[0].get("typeContrat")}
                      nomEntreprise={offre[0].get("entreprise")}
                      adresseEntreprise={offre[0].get("adresse")}
                      dateDebut={moment(offre[0].get("dateDebut"))
                        .locale("fr")
                        .format("LLLL")
                        .toString()}
                      resume={offre[0].get("resume")}
                      showMissionsLabel={
                        offre[0].get("missions") ? true : false
                      }
                      missions={offre[0].get("missions")}
                      url={
                        offre[0].get("logoEnterprise") !== undefined
                          ? offre[0].get("logoEnterprise").url()
                          : undefined
                      }
                    />
                  </Box>
                </Grid.Col>
                <Grid.Col key="2" xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Box
                    ms={["0px", "0px", "0px", "0px"]}
                    mt={["50px", "50px", "0px", "0px"]}
                    bg="#d4eeff"
                    w="100%"
                    height={["", "", "740px", "740px"]}
                    p={4}
                    borderRadius="20px"
                  >
                    <Text
                      fontFamily={"Sofia Pro"}
                      fontStyle={"normal"}
                      fontSize={"24px"}
                      fontWeight={900}
                      align="left"
                      ms={"30px"}
                    >
                      Nombre de candidatures
                    </Text>
                    {candidatsToShow ? (
                      <Box display={"flex"}>
                        <Text
                          fontFamily={"Sofia Pro"}
                          fontSize={"14px"}
                          fontStyle={"normal"}
                          fontWeight={300}
                          pt={2.5}
                          align="left"
                          ms={"30px"}
                        >
                          Actuellement, il y a
                        </Text>
                        <Text
                          fontFamily={"Sofia Pro"}
                          fontSize={"24px"}
                          fontStyle={"normal"}
                          fontWeight={900}
                          align="left"
                          ms={"5px"}
                        >
                          {candidatsToShow.length}
                          {candidatsToShow.length > 1
                            ? " candidats"
                            : " candidat"}
                        </Text>
                      </Box>
                    ) : (
                      ""
                    )}
                    <Box
                      maxH={["400px", "400px", "650px", "650px"]}
                      overflowY={"auto"}
                    >
                      {candidatsToShow
                        ? candidatsToShow.map((userId) => {
                            return (
                              <Box key={userId} ml={"20px"} my={"10px"}>
                                <ShowUser
                                  hide={true}
                                  showMetier={true}
                                  showAvatarOnly={false}
                                  offre={offre[0]}
                                  userId={userId}
                                  offreId={offreId}
                                ></ShowUser>
                              </Box>
                            );
                          })
                        : ""}
                    </Box>
                  </Box>
                </Grid.Col>
              </Grid>
            </Flex>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default AfficherOffres;
